<!-- El shell YA CABLEADO: `[marca]` es lo único propio de esta aplicación. Los
     módulos, el usuario de la barra, las tarjetas de acceso, el acceso vigente,
     la salida de sesión y el cambio de aplicación los resuelve
     `<intelishs-shell-sesion>` leyendo `SesionService`.

     No lleva `[modulos]`: los de RH SÍ están otorgados al rol en la base (7 para
     `administrador-rh`, 3 para `director-rh`, 1 para `empleado-rh`), así que
     salen de la sesión. El input existe para el portal de administración, cuyo
     rol tiene cero porque su acceso es derivado. -->
<intelishs-shell-sesion [marca]="marca">
  <router-outlet />
</intelishs-shell-sesion>

<!-- Visor de archivos global: se monta una sola vez y cualquier componente lo
     abre inyectando FileViewerService y llamando showPreview(). -->
<intelishs-file-viewer />

<!-- Volver al inicio: también una sola vez, no por página. Aparece cuando ya se
     bajó lo suficiente, en cualquier ruta con scroll (expediente, formulario,
     tablas largas). Sustituye a la barra de acciones sticky, que el shell no
     permite —ver el comentario de `.page-actions--bar` en styles.css—. -->
<intelishs-back-to-top />
